(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
let 
  collGallery = document.querySelector('.coll-product-image img'),
  productCards = document.querySelectorAll('.product-card');

productCards.forEach(card => {
  let detailImgUrl = card.getAttribute('data-detail');

  card.addEventListener('mouseover', function() {
    collGallery.setAttribute('src', detailImgUrl)
  })
});


  } catch(e) { console.error(e); }
})();
})();
